import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate } from "react-router-dom";
import "./Datatable.css";
import Swal from "sweetalert2";
import "font-awesome/css/font-awesome.min.css";
import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PdfModal from "./PdfModel";

const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

const JobApplicationTable = () => {
  const [form2Events, setForm2Events] = useState([]);
  const [alert, setAlert] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchItem, setSearchItem] = useState("");
  const [itemsPerPage] = useState(10);
  const [totalCareers, setTotalCareers] = useState(0);
  const [showIframe, setShowIframe] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState("");

  const handlePdfClick = (pdfUrl) => {
    setSelectedPdf(pdfUrl);
    setShowPdfModal(true);
  };
  const navigate = useNavigate();

  const handleClick = (id, firstName) => {
    // console.log(title,"title")
    Swal.fire({
      title: "Job Application Details",
      text: "",
      html: `
        <p class="confimrmodel">Are you sure you want to delete?</p>
        <p>${firstName}</p>
        <p class="warnmodel">
          <i class="fa fa-exclamation-triangle" style="font-size: 18px; color: #d33; margin-right: 8px;"></i>
          <span>You cannot recover the data after deleting.</span>
        </p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id); // Call handleDelete after confirmation
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (page = 1, searchQuery = "") => {
    try {
      const response2 = await axios.get(
        `${CONFIG.BASE_URL}/career/application/get/all?page=${page}&limit=${itemsPerPage}&search=${searchQuery}`
      );
      // console.log(response2,"response2>>")
      setForm2Events(response2.data.application);
      setTotalCareers(response2.data.totalApplication);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchItem);
  }, [currentPage, searchItem]);

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
    debouncedSearch(e.target.value);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${CONFIG.BASE_URL}/career/application/delete/${id}`);
      setForm2Events((prevEvents) =>
        prevEvents.filter((event) => event._id !== id)
      );
      toast.success("Job Application deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      toast.error("Error!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };
  const debouncedSearch = useCallback(
    debounce((query) => {
      fetchData(1, query);
      setCurrentPage(1);
    }, 500),
    [fetchData]
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(totalCareers / itemsPerPage);

  const paginatedData = form2Events.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="custom-table-container wow fadeInUp">
      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="breadcrumb-title pe-3">
          <ToastContainer />

          <h5>Job Application Details</h5>
          {alert && (
            <CustomAlert
              message={alert.message}
              onClose={() => setAlert(null)}
              type={alert.type}
            />
          )}
        </div>

        <div className="ms-auto d-flex">
          <div className="btn-group w-100 pe-3">
            <div className="search-container w-100">
              <input
                className="form-control search-input"
                type="text"
                placeholder="Search..."
                value={searchItem}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Job Id</th>
            <th>Job Title</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Resume</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {form2Events.map((item, index) => (
            <tr key={item._id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{item.applicationId}</td>
              <td>{item.jobTitle}</td>

              <td>{item.firstName}</td>

              <td>{item.phone}</td>
              <td>
                <i
                  className="fa fa-file-pdf"
                  style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                  onClick={() => handlePdfClick(item.resume)}
                ></i>
              </td>
              <td className="status_wrap">
                <button
                  className="custom-btn-view"
                  style={{ background: "#4a3c3b" }}
                  onClick={() =>
                    navigate("/view-job-application", {
                      state: { jobProbsData: item, isEditing: true },
                    })
                  }
                >
                  {" "}
                  <i className="fa fa-eye" style={{ color: "white" }}></i> {}
                </button>
                <button
                  className="custom-btn-delete"
                  onClick={() => handleClick(item._id, item.firstName)}
                >
                  <i className="fa fa-trash" style={{ color: "white" }}></i> {}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showPdfModal && (
        <PdfModal pdfUrl={selectedPdf} onClose={() => setShowPdfModal(false)} />
      )}

      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>

        {Array.from({ length: 7 }).map((_, index) => {
          const pageNumber =
            currentPage <= 6 ? index + 1 : currentPage + index - 2;

          if (pageNumber < 1 || pageNumber > totalPages) {
            return null;
          }

          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={currentPage === pageNumber ? "active" : ""}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default JobApplicationTable;
